var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Helmet } from 'react-helmet';
import { makeSelectAppsMeta, selectOrganizationId, } from '@project/containers/Root/selectors';
import AppList from '@project/components/AppList';
import { PageHeader, PageHeaderTitle, PageHeaderControls, AddToDashButton, HelpButton, PageWrapper, } from '@project/components/Page';
import Breadcrumbs from '@project/components/OrgBreadcrumbs';
import { loadApps } from '@project/containers/Root/actions';
import Search from '@project/components/Search/Search.element';
import { ContentPadding } from '../../components/base';
import HelpModal from '../../components/IntroModalBox/HelpModal';
import WelcomeModal from '../../components/IntroModalBox/WelcomeModal';
import { PageContent } from '../Root/styles';
import storageService from '../../utils/storageService';
import GetStartedSection from '../../components/OrgDashboardComponents/GetStartedSection';
import { AppsHeading, AppsRight, ButtonsWrapper, ButtonFrame, ButtonFrameWrapper, ListIcon, } from './styles';
import { faList } from '@fortawesome/pro-regular-svg-icons/faList';
import { faTh } from '@fortawesome/pro-solid-svg-icons/faTh';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
var AppsPage = /** @class */ (function (_super) {
    __extends(AppsPage, _super);
    function AppsPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedView: Number(storageService.getItem('appPageView')),
            viewChanged: 2,
            searchValue: '',
        };
        _this.actions = {
            getSelectedView: function () { return storageService.getItem('appPageView'); },
            setSelectedView: function (selectedView) {
                _this.setState({ selectedView: selectedView });
            },
            viewChange: function (viewChanged) {
                _this.setState({ viewChanged: viewChanged });
            },
            searchValueChange: function (searchValue) {
                _this.setState({ searchValue: searchValue });
            },
        };
        return _this;
    }
    AppsPage.prototype.componentDidMount = function () {
        this.props.loadApps();
        if (!this.actions.getSelectedView()) {
            this.setState({ selectedView: 1 });
        }
        else {
            this.setState({ selectedView: Number(this.actions.getSelectedView()) });
        }
    };
    AppsPage.prototype.componentDidUpdate = function (_, prevState) {
        if (prevState.selectedView !== this.state.selectedView) {
            storageService.setItem('appPageView', this.state.selectedView);
        }
    };
    AppsPage.prototype.render = function () {
        var _this = this;
        var crumbs = [{ to: '', text: 'My Apps' }];
        return (_jsxs(PageWrapper, { children: [_jsxs(PageHeader, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: "Apps" }), _jsx("meta", { name: "description", content: "List of apps" })] }), _jsxs(PageHeaderTitle, { children: [_jsx(Breadcrumbs, { crumbs: crumbs }), _jsx(HelpModal, {}), _jsx(WelcomeModal, {})] }), _jsxs(PageHeaderControls, { children: [_jsx(AddToDashButton, {}), _jsx(HelpButton, { currentLocation: 'organizations/gCpxxOYolcBjbqIrSzqOfNfysTYdflKkHOiUlQVB/apps' })] })] }), _jsx(PageContent, { children: _jsxs(ContentPadding, { children: [_jsx(GetStartedSection, {}), _jsxs(AppsHeading, { children: [_jsx("div", { children: "Apps" }), _jsxs(AppsRight, { children: [_jsx(Search, { dark: true, placeholder: "Search apps", onChangeFilter: this.actions.searchValueChange, type: "TABLE" }), _jsxs(ButtonFrameWrapper, { children: [_jsx(ButtonFrame, {}), _jsxs(ButtonsWrapper, { children: [_jsx(ListIcon, __assign({ selected: this.state.selectedView === 2, onClick: function () { return _this.actions.setSelectedView(2); } }, { children: _jsx(FontAwesomeIcon, { icon: faList, color: this.state.selectedView === 2 ? '#fff' : '#c2c2c2' }) })), _jsx(ListIcon, __assign({ selected: this.state.selectedView === 1, onClick: function () { return _this.actions.setSelectedView(1); } }, { children: _jsx(FontAwesomeIcon, { icon: faTh, color: this.state.selectedView === 1 ? '#fff' : '#c2c2c2' }) }))] })] })] })] }), _jsx(AppList, { selectedView: this.state.selectedView, searchValue: this.state.searchValue })] }) })] }));
    };
    return AppsPage;
}(React.Component));
export { AppsPage };
var mapDispatchToProps = function (dispatch) { return ({
    loadApps: function () {
        dispatch(loadApps());
    },
}); };
var mapStateToProps = createStructuredSelector({
    meta: makeSelectAppsMeta(),
    orgId: selectOrganizationId,
});
var withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(AppsPage);
